"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addCookieConsentBanner = exports.shouldAddCookieConsentBanner = exports.getCookieConsentBannerExtraQueryParam = void 0;
const config_1 = __importDefault(require("../../build-babel/auth/client/config"));
const js_cookie_1 = __importDefault(require("js-cookie"));
const URL_GET_PARAM_NAME = 'disableCookieConsentBanner';
const DISABLE_COOKIE_CONSENT_COOKIE_NAME = 'disableCookieConsentBanner';
const setDisableCookieConsentCookie = disableCookieConsentBanner => {
  js_cookie_1.default.set(DISABLE_COOKIE_CONSENT_COOKIE_NAME, disableCookieConsentBanner.toString());
};
const getDisableCookieConsentCookie = () => {
  const cookie = js_cookie_1.default.get(DISABLE_COOKIE_CONSENT_COOKIE_NAME);
  return !!(cookie && cookie === 'true');
};
const getCookieConsentBannerExtraQueryParam = () => {
  if (!(0, exports.shouldAddCookieConsentBanner)()) {
    return {
      [URL_GET_PARAM_NAME]: 'true'
    };
  }
};
exports.getCookieConsentBannerExtraQueryParam = getCookieConsentBannerExtraQueryParam;
const shouldAddCookieConsentBanner = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const disableCookieConsentBannerParam = urlParams.get(URL_GET_PARAM_NAME);
  if (disableCookieConsentBannerParam === null) {
    return !getDisableCookieConsentCookie();
  }
  const disableCookieConsentBanner = !!(disableCookieConsentBannerParam && disableCookieConsentBannerParam === 'true');
  setDisableCookieConsentCookie(disableCookieConsentBanner);
  return !disableCookieConsentBanner;
};
exports.shouldAddCookieConsentBanner = shouldAddCookieConsentBanner;
const addCookieConsentBanner = () => {
  const envConfig = (0, config_1.default)();
  if (envConfig) {
    const cookieBannerScript = document.createElement('script');
    cookieBannerScript.src = `${envConfig.globalFrontendScripts}/cookieBanner.js`;
    document.head.appendChild(cookieBannerScript);
  }
};
exports.addCookieConsentBanner = addCookieConsentBanner;
//# sourceMappingURL=index.js.map